import { createSlice } from '@reduxjs/toolkit'

import { attributesAdapter } from './attributesAdapters'

export const initialAttributesState = attributesAdapter.getInitialState()

export const attributesSlice = createSlice({
  name: 'attributes',
  initialState: initialAttributesState,
  reducers: {
    upsertMultipleAttributes: (state, action) => {
      attributesAdapter.upsertMany(state, action.payload)
    },
    replaceAllAttributes: (state, action) => {
      attributesAdapter.setAll(state, action.payload)
    },
  },
})

export const { upsertMultipleAttributes, replaceAllAttributes } = attributesSlice.actions